
import React, { useRef } from 'react'
import { useGLTF,useTexture } from '@react-three/drei'
import {  useFrame } from '@react-three/fiber'

export default function JoyStick(props) {
  const { nodes, materials } = useGLTF('./models/joystick_v01.gltf')
  const colors = props.colors
  const [matcap,matcap2] = useTexture([
    'img/matcap.jpg',
    'img/matcap2.jpg'
  ])

  const joystickGroup =useRef()
  const deg= Math.PI*2/360
  useFrame(()=>{

    joystickGroup.current.rotation.z = (props.normalPos.x * -25* deg)
    joystickGroup.current.rotation.x = (props.normalPos.y * 20* deg)

    }
      
    )

  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.wireShadow.geometry}
        material={nodes.wireShadow.material}
        position={[-0.029, -0.001, -0.05]}
        >
      <meshBasicMaterial  color={props.isDark?colors.shadowNight:colors.shadowDay}/>
      </mesh>
      <mesh
        geometry={nodes.wire.geometry}
        material={nodes.wire.material}
        position={[-0.026, 0.002, -0.047]}
        >
      <meshMatcapMaterial matcap={matcap2} color={props.isDark?colors.night:colors.day}/>
      </mesh>
      <mesh
        geometry={nodes.Extrude.geometry}
        material={nodes.Extrude.material}
        position={[0, 0.025, 0]}
        >
        <meshMatcapMaterial matcap={matcap} color={props.isDark?colors.night:colors.day}/>
        </mesh>
      <mesh
        geometry={nodes.button.geometry}
        material={nodes.button.material}
        position={[0.025, 0.031, 0.027]}
        >
      <meshMatcapMaterial matcap={matcap} color={props.isDark?colors.night:colors.day}/>
      </mesh>

          <mesh ref={joystickGroup}
            geometry={nodes.JoyStick_ball.geometry}
            material={nodes.JoyStick_ball.material}
            position={[-0.02, 0.014, -0.02]}>
            <mesh
              geometry={nodes.stick.geometry}
              material={nodes.stick.material}
              position={[0, 0.029, 0]}
              >
            <meshMatcapMaterial matcap={matcap2} color={props.isDark?colors.night:colors.day}/>
            </mesh>
            <mesh
              geometry={nodes.tip.geometry}
              material={nodes.tip.material}
              position={[0, 0.043, 0]}
              >
            <meshMatcapMaterial matcap={matcap2} color={props.isDark?colors.night:colors.day}/>
            </mesh>
          
          <meshMatcapMaterial matcap={matcap} color={props.isDark?colors.night:colors.day}/>
      
          </mesh>

      <mesh geometry={nodes.Extrude1.geometry} material={nodes.Extrude1.material} position={[0, -0.001, -0.01]}>
        <meshBasicMaterial  color={props.isDark?colors.shadowNight:colors.shadowDay}/>
        </mesh>
    </group>
   
      
  )
}

useGLTF.preload('/joystick_v01.gltf')
